/* eslint-disable no-use-before-define ,no-dupe-keys , jsx-a11y/label-has-associated-control,object-shorthand */



import React, { useState, useEffect } from 'react';
import { Link ,useHistory} from 'react-router-dom';
import { 
  sanitizeInput, 
  validateEmail, 
  validateName, 
  useRateLimit, 
  // SecurityMonitor,
  isSecureContext, 
  secureApiCall
} from './utils/security';
import CustomDropdown from './CustomDropdown';
import './Registration.css';
import CommonDialog from 'components_newui/dialogs/CommonDialog';
// import images from 'common_constants/images';
import logo_red  from '../../img/innovate/Innovation_Logo.jpg'

const Registration = () => {
  const history = useHistory()
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [isloading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [countryCode, setCountryCode] = useState('');
  const { canSubmit, recordAttempt } = useRateLimit(3, 60000);

  const [formData, setFormData] = useState({
    firstName: '',
    lastName:'',
    email: '',
    additionalOption: '',
    countryCode:countryCode
  });


// based on market selecte country id
const marketCountryIDMap = {
  'South Africa': 'ZA',
  'Lesotho': 'LS',
  'DRC': 'CD',
  'Tanzania': 'TZ',
  'Mozambique': 'MZ',
  'Kenya': 'KE',
  'Ethiopia': 'ET',
  'Egypt': 'EG',
  'IoT.nxt': 'ZA',
  'X-Link': 'ZA',
  'Mezzanine': 'ZA',
  'Nexio': 'ZA'
};


  const domainToMarket = {
    // South Africa
    'vodacom.co.za': 'South Africa',
    'vcontractor.co.za': 'South Africa',
    'iotnxt.com': 'South Africa',
    'nexio.co.za': 'South Africa',
    'xlink.co.za': 'South Africa',
    'mezzanineware.com': 'South Africa',
  
    // Lesotho
    'vodacom.ls': 'Lesotho',
    'vodacom.co.ls': 'Lesotho',
  
    // DRC
    'vodacom.cd': 'DRC',
    'm-pesa.cd': 'DRC',
  
    // Tanzania
    'vcontractor.co.tz': 'Tanzania',
    'vodacom.co.tz': 'Tanzania',
    'mpesa.co.tz': 'Tanzania', // Note: trailing dot may be a typo
    'm-pesa.co.tz': 'Tanzania',
  
    // Mozambique
    'vm.co.mz': 'Mozambique',
  
    // Kenya
    'safaricom.co.ke': 'Kenya',
  
    // Ethiopia
    'safaricom.et': 'Ethiopia',
  
    // Egypt
    // ' vodafone.com': 'Egypt', // Special case: select on login screen
    'vodafone.com.eg': 'Egypt',
  
    // IoT.nxt
    'iotnxt.com': 'IoT.nxt',
  
    // X-Link
    'xlink.co.za': 'X-Link',
  
    // Mezzanine
    'mezzanineware.com': 'Mezzanine',
  
    // Nexio
    'nexio.co.za': 'Nexio'
  };

  const validDomains = Object.keys(domainToMarket);

  // Get market options based on email domain
  const getMarketOptions = () => {
    if (!formData.email || !validateEmail(formData.email)) {
      return [];
    }
    
    const domain = getEmailDomain(formData.email);
    const market = domainToMarket[domain];
    // Return only the market that corresponds to the email domain
    return market ? [market] : [];
  };

  // Clear market selection when email changes
  useEffect(() => {
    setFormData(prev => ({
      ...prev,
      additionalOption: '',
      countryCode:'',
    }));
  }, [formData.email]);

  // Security check on component mount
  useEffect(() => {
    if (!isSecureContext() && process.env.NODE_ENV === 'production') {
      console.warn('This application should be accessed over HTTPS');
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const sanitizedValue = sanitizeInput(value);
    
    setFormData({
      ...formData,
      [name]: sanitizedValue
    });

    // const domain = getEmailDomain(formData.email);
    // const market = domainToMarket[domain];
    // const cid= marketCountryIDMap[market] || ''

    // console.log("cid   ", cid)
    // setCountryCode(cid)

    // Clear validation error when user starts typing
    if (validationErrors[name]) {
      setValidationErrors({
        ...validationErrors,
        [name]: ''
      });
    }
  };



  
const handleMarketChange = (e) => {
  const selectedMarket = e.target.value;
  setFormData((prev) => ({
    ...prev,
    additionalOption: selectedMarket,
    countryCode: marketCountryIDMap[selectedMarket] || '',
  }));
};



  const handleSubmit = (e) => {
    e.preventDefault();
    
    // if (!canSubmit()) {
    //   SecurityMonitor.trackRateLimitExceeded('registration');
    //   alert('Too many attempts. Please wait before trying again.');
    //   return;
    // }
    
    // if (!validateForm()) {
    //   SecurityMonitor.trackEvent('FORM_VALIDATION_FAILED', { form: 'registration' });
    //   return;
    // }
    recordAttempt();

    secureApiCall('api/v1/user/create',{
     method: 'POST',
     body: JSON.stringify(formData),} );

    // UI only - no actual registration logic
    console.log('Registration attempt:', formData);
  };


  const setContent = (formdataRes) => {
    // console.log("🚀 ~ setContent ~ formdataRes:", formdataRes)
    const {
      email,
      additionalOption,
      countryCode:marketCountryCode,
      firstName,
      lastName
    } = formdataRes;
  
    return `${encodeURIComponent('email')}=${encodeURIComponent(email)}&` +
           `${encodeURIComponent('firstName')}=${encodeURIComponent(firstName)}&` +
           `${encodeURIComponent('lastName')}=${encodeURIComponent(lastName)}&` +
           `${encodeURIComponent('market')}=${encodeURIComponent(additionalOption)}&` +
           `${encodeURIComponent('country')}=${encodeURIComponent(marketCountryCode)}`;
  };
  
const redirectLoginpage = () => {
  setShowSuccessModal(false)
  history.push('/login')

}

  const handleInviteFn = async (e) => {
    e.preventDefault();
    recordAttempt();
    try {
      setLoading(true); // Optional: if you have a loading state
      const body = setContent(formData); // ✅ Call the function with formData
  
      const response = await secureApiCall('b/create-invite-user', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body,
      });
      console.log('API response:', response);

  // ✅ Show success modal
  setShowSuccessModal(true)

    } catch (error) {
      console.error('API error:', error);
      // Show error to user or set error state
    } finally {
      setLoading(false); // ✅ Ensure loading is reset even on error
    }
  
    console.log('Registration attempt:', formData);
  };
  

  const getEmailDomain = (email) => {
    if (!validateEmail(email)) return '';
    const parts = email.split('@');
    return parts.length === 2 ? parts[1].toLowerCase() : '';
  };

  const isValidDomain = () => {
    if (!formData.email || !validateEmail(formData.email)) return false;
    const domain = getEmailDomain(formData.email);
    return validDomains.includes(domain);
  };



  // Enhanced form validation
  const validateForm = () => {
    const errors = {};
    
    // Name validation
    if (!validateName(formData.fullName)) {
      errors.fullName = 'Please enter a valid name';
    }
    
    // Email validation
    if (!validateEmail(formData.email)) {
      errors.email = 'Please enter a valid email address';
    } else if (!isValidDomain()) {
      errors.email = 'Email domain not authorized for registration';
    }
    
    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const showAdditionalOption = isValidDomain();

// shows a text message only when the email domain is @vodafone.com 
const isVadafoneDomain = () => {
  const domain = getEmailDomain(formData.email);
  return domain === 'vodafone.com';
};

const isVadafoneDomainReturn = isVadafoneDomain()
// console.log("🚀 ~ Registration ~ isVadafoneDomainReturn:", isVadafoneDomainReturn)

  // Check if form is valid for button state
  const isFormValid = () => {
    return validateName(formData.firstName) && 
           validateEmail(formData.email) &&
           isValidDomain() &&
           formData.additionalOption !== '';
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <div className="nova-logo">
            {/* <span className="nova-text">Innovate</span>
            <span className="nova-plus">+</span> */}
            <img className="logored"  src={logo_red} alt="logo" />
          </div>
          <h1>New User Registration</h1>
          <p>Join the Innovate+ community</p>
        </div>
        
        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="firstName">First Name</label>
            <input
              type="text"
              id="firstName"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              required
              placeholder="Enter your first  name"
            />
          </div>

          <div className="form-group">
            <label htmlFor="lastName">Last Name</label>
            <input
              type="text"
              id="lastName"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              
              placeholder="Enter your last name"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="Enter your email address"
            />
            {validationErrors.email && (
              <div className="error-message">
                <small>{validationErrors.email}</small>
              </div>
            )}
            {isVadafoneDomainReturn && (
              <div className="info-message">
                <small>Note: Users with @vodafone.com, please login with SSO. <a className="auth-link" href="/">Sign in here</a></small>
              </div>
            )}
          </div>
          
          {showAdditionalOption && (
            <div className="form-group">
              <label htmlFor="additionalOption">Select Market</label>
              <CustomDropdown
                name="additionalOption"
                value={formData.additionalOption}
                onChange={handleMarketChange}
                placeholder="Select Market"
                options={getMarketOptions()}
              />
            </div>
          )}

{/* {console.log("formData?.countryCode", formData?.countryCode, countryCode)} */}
          {
            showAdditionalOption && (
              <div className="form-group">
                {/* <label>Country Code:</label> */}
                <select value={formData?.countryCode} disabled hidden>
                  <option value="">{formData?.countryCode ? formData?.countryCode : 'Select Market First'}</option>
                </select>

              </div>
            )
          }

          
          {/* <button 
            type="submit" 
            className={`auth-button primary ${!isFormValid() ? 'disabled' : ''}`}
            disabled={!isFormValid()}
          >
            Create Account
          </button> */}
          <button 
            type="button"
            onClick={handleInviteFn} 
            className={`auth-button primary ${!isFormValid() ? 'disabled' : ''}`}
            disabled={!isFormValid()}
          >
            {/* Invite User  */}
           {isloading ? " Loading... " : 'Create Account' }   
          </button>
        </form>
        
        <div className="auth-footer">
          <p>
            Already have an account? 
            <Link to="/login" className="auth-link">Sign in here</Link>
          </p>
        </div>
      </div>

      <CommonDialog
          open={showSuccessModal}
          title="Registration successfully!"
          cancelText='Okay'
          hideSubmitBtn
          content='The email is on its way! Check your inbox in a few moments and follow the instructions to set your password.'
          onClose={redirectLoginpage}
          // onConfirm={null}
          // disabled={childValueSelectedUserTags?.length <= 0}
        /> 


    </div>
  );
};

export default Registration;
